export enum PollTypesEnum {
    POLL_OFF = "POLL_OFF",
    POLL_VISIBLE = "POLL_VISIBLE",
    POLL_HIDDEN = "POLL_HIDDEN",
    POLL_QUIZ = "POLL_QUIZ",
    POLL_IMAGES = "POLL_IMAGES",
    POLL_RATING = "POLL_RATING",
}
